<template>
    <div>
        <type-ahead
            :dispatch="'widgetData/getValues'"
            :code="item.code"
            :values="item.values"
            :getResponse="getResponse"
            :onHit="onHit"
            :maxlength="100"
            :placeholder="'Enter Keywords'"
            :examples="examples"
        />

        <checkboxes
            v-if="item.values.length"
            :item="item"
            :viewAll="false"
            :classes="'max-h-[300px] overflow-y-auto overflow-x-hidden mt-2'"
        />
    </div>
</template>

<script>
    import Mark from "mark.js";
    import TypeAhead from "@widget/components/ui/type-ahead";
    import { EventBus } from "@widget/plugins/event-bus";
    import Checkboxes from "@widget/components/selections/types/checkboxes";

    export default {
        name: "autocomplete",
        props: {
            item: {
                type: Object,
                require: true,
                default: () => {
                    return {};
                }
            }
        },
        computed: {
            examples () {
                if (this.item.code === "b2b_job_titles") {
                    return "Examples: 'medical doctor/physician, student, etc.'";
                }

                return "";
            },
            selectedData () {
                return this.$store.getters["widgetData/selectedData"];
            }
        },
        components: {
            TypeAhead,
            Checkboxes
        },
        methods: {
            getResponse ({ data: { data: response } }) {
                return response;
            },
            onHit (item, vue) {
                let selectStore = this.$store.getters["widgetData/getSelectByCode"](this.item.code);
                let query = [];
                let queryUI = [];
                if (selectStore) {
                    query = selectStore.query;

                    if (query.includes(item.value)) {
                        vue.query = "";
                        return;
                    }

                    query.push(item.value);
                    queryUI = selectStore.queryUI ?? [];
                    queryUI.push(item.title);
                } else {
                    query.push(item.value);
                    queryUI.push(item.title);
                }
                this.$store.commit("widgetData/addSelect", {
                    sensitive: this.item.attentionText !== "",
                    code: this.item.code,
                    group: this.item.group,
                    title: `${this.item.title}: ${queryUI.join(", ")}`,
                    queryUI,
                    query
                });
                vue.query = "";
            }
        },
        data () {
            return {
                loading: false,
                src: null,
                markInstance: new Mark("ul.dropdown-menu-list")
            };
        },
        mounted () {
            EventBus.$on("remove-select", code => {
                if (code === this.item.code) {
                    this.$emit("close");
                }
            });
        }
    };
</script>
